import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MissionCreationState {
  currentMissionId: string | null;
  isCreating: boolean;
  recordMode: "waypoint" | "photo" | "stair" | null;
  /** Edit chrome for the mission subpage; shared so the map can gate waypoint pin editing. */
  editMode: boolean;
}

const initialState: MissionCreationState = {
  currentMissionId: null,
  isCreating: false,
  recordMode: null,
  editMode: false,
};

export const missionCreationSlice = createSlice({
  name: 'missionCreation',
  initialState,
  reducers: {
    setCurrentMission: (state, action: PayloadAction<string | null>) => {
      state.currentMissionId = action.payload;
      // Every mission open (list / auto-open of a run / wizard) starts with edit chrome off.
      state.editMode = false;
    },
    setIsCreating: (state, action: PayloadAction<boolean>) => {
      state.isCreating = action.payload;
    },
    setRecordMode: (state, action: PayloadAction<"waypoint" | "photo" | "stair" | null>) => {
      state.recordMode = action.payload;
    },
    setEditMode: (state, action: PayloadAction<boolean>) => {
      state.editMode = action.payload;
    },
    clearMissionCreation: (state) => {
      state.currentMissionId = null;
      state.isCreating = false;
      state.recordMode = null;
      state.editMode = false;
    },
  },
});

export const {
  setCurrentMission,
  setIsCreating,
  setRecordMode,
  setEditMode,
  clearMissionCreation,
} = missionCreationSlice.actions;
export default missionCreationSlice.reducer;
